import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { COMPANY } from '../../const/company';
import CompanyRouter from '../CompanyRouter';

import CloseView from './pages/CloseView';
import QvCloseView from './pages/qv/QvCloseView';
import DaishinCloseView from './pages/daishin/DaishinCloseView';
import HyundairsCloseView from './pages/hyundairs/HyundairsCloseView';

const COMPANY_VIEW = {
  [COMPANY.QV.id]: QvCloseView,
  [COMPANY.DAISHIN.id]: DaishinCloseView,
  [COMPANY.HYUNDAIRS.id]: HyundairsCloseView,
};

@observer
class CloseRouter extends Component {
  render() {
    return (
      <CompanyRouter
        map={COMPANY_VIEW}
        fallback={CloseView}
        {...this.props}
      />
    );
  }
}

export default CloseRouter;
